import * as React from "react";
import { utilButton } from "../../../utils/utilButton";
export var Button = function (_a) {
    var children = _a.children, onClick = _a.onClick, className = _a.className, disabled = _a.disabled, style = _a.style;
    return (React.createElement("button", { onClick: function () { return utilButton.onClickWithSound(onClick); }, className: className, disabled: disabled, style: style }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/button/Button.tsx
// module id = 312
// module chunks = 3